var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTelefono(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46 40.6",
    style: {
      enableBackground: "new 0 0 46 40.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,15.2c0.4-0.4,0.8-0.9,1.1-1.6c0.9-2.2,0.5-2.6,0.5-2.6c-0.6-1.3-1.8-2.9-3.5-4.6 c-1.6-1.7-3.3-2.9-4.6-3.5c0,0-2-0.6-3.6,0.9c0,0,0,0,0,0h0l0,0C8.3,4.1,8.1,4.3,7.9,4.5L18.6,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,31.2c-0.6-1.3-1.8-2.9-3.5-4.6c-1.7-1.6-3.3-2.9-4.6-3.5c0,0-0.4-0.4-2.6,0.5c-0.6,0.3-1.2,0.8-1.6,1.1 l10.7,10.7c0.2-0.2,0.4-0.4,0.6-0.6l0,0c0,0,0,0,0,0c0,0,0,0,0,0C41,33.2,40.4,31.2,40.4,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,26.2c-0.3,0.5-0.9,0.6-1.5,0.6c-1.9,0-4.9-1.7-6.1-3c-1.6-1.6-4.1-6.2-2.3-7.6c0.1-0.1,0.2-0.1,0.3-0.2 L7,5.7C5.4,8.1,5.5,10,5.5,10s-0.3,8.6,9.5,18.3c9.2,9.2,17.4,9.5,18.3,9.5c0,0,0.1,0,0.1,0s0,0,0,0c0.3,0,2,0,4.2-1.5L27.2,25.9 C27.1,26,27,26.1,27,26.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "85,11.4 85,33.8 98.5,22.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.7,4.5H88.6c-1.8,0-3.2,1.3-3.5,3l17.8,14.8l3,2.5c1,0.8,2.7,0.8,3.7,0l3.1-2.6l17.6-14.6 C129.9,5.8,128.5,4.5,126.7,4.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "130.3,33.8 130.3,11.4 116.8,22.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.9,26.7l-2.4,2c-1,0.8-2.7,0.8-3.7,0l-3.1-2.6l-1.8-1.5L86.4,36.7c0.6,0.5,1.4,0.8,2.2,0.8h38.1 c0.8,0,1.6-0.3,2.2-0.8l-14.5-12.1L111.9,26.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelefono);
export default __webpack_public_path__ + "static/media/icon-telefono.0787677423dd99b6e420d88b05d079f6.svg";
export { ForwardRef as ReactComponent };